// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: rEFVLslupc
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import { AntdSelect } from "@plasmicpkgs/antd5/skinny/registerSelect";
import { Select } from "@plasmicpkgs/antd/skinny/registerSelect";
import { Option } from "@plasmicpkgs/antd/skinny/registerOption";
import PermissionChip from "../../PermissionChip"; // plasmic-import: BXt7q3K2tv/component
import Button from "../../Button"; // plasmic-import: qD6dz0yVMKR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicEditRoleModal.module.css"; // plasmic-import: rEFVLslupc/css

createPlasmicElementProxy;

export const PlasmicEditRoleModal__VariantProps = new Array();

export const PlasmicEditRoleModal__ArgProps = new Array();

const $$ = {};

function PlasmicEditRoleModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "roleName.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: p.generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "permissionSelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "permissionSelectionStack.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "permissionSelectionStack.open",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__ym7Cu)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__m9BVx
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h6
                className={classNames(
                  projectcss.all,
                  projectcss.h6,
                  projectcss.__wab_text,
                  sty.h6__s88Tg
                )}
              >
                {"Edit Role Name"}
              </h6>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__d3CnF)}>
        {(() => {
          const child$Props = {
            className: classNames("__wab_instance", sty.roleName),
            onChange: p.generateStateOnChangePropForCodeComponents(
              $state,
              "value",
              ["roleName", "value"],
              AntdInput_Helpers
            ),
            placeholder: "Enter Here",
            value: p.generateStateValueProp($state, ["roleName", "value"])
          };
          p.initializeCodeComponentStates(
            $state,
            [
              {
                name: "value",
                plasmicStateName: "roleName.value"
              }
            ],

            [],
            AntdInput_Helpers ?? {},
            child$Props
          );
          return (
            <AntdInput
              data-plasmic-name={"roleName"}
              data-plasmic-override={overrides.roleName}
              {...child$Props}
            />
          );
        })()}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__ybw3V)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__kioBo
          )}
        >
          <React.Fragment>
            <React.Fragment>{""}</React.Fragment>
            {
              <h6
                className={classNames(
                  projectcss.all,
                  projectcss.h6,
                  projectcss.__wab_text,
                  sty.h6___53BFa
                )}
              >
                {"Add permissions"}
              </h6>
            }

            <React.Fragment>{""}</React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"permissionSelectStack"}
        data-plasmic-override={overrides.permissionSelectStack}
        className={classNames(projectcss.all, sty.permissionSelectStack)}
      >
        <AntdSelect
          data-plasmic-name={"permissionSelect"}
          data-plasmic-override={overrides.permissionSelect}
          autoFocus={false}
          className={classNames("__wab_instance", sty.permissionSelect)}
          defaultOpen={false}
          defaultStylesClassName={classNames(
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens
          )}
          dropdownMatchSelectWidth={true}
          mode={"single"}
          onChange={p.generateStateOnChangeProp($state, [
            "permissionSelect",
            "value"
          ])}
          options={[
            { value: "option1", label: "Option 1", type: "option" },
            { value: "option2", label: "Option 2", type: "option" }
          ]}
          placeholder={"Select..."}
          popupScopeClassName={sty["permissionSelect__popup"]}
          value={p.generateStateValueProp($state, [
            "permissionSelect",
            "value"
          ])}
        />

        <Select
          data-plasmic-name={"permissionSelectionStack"}
          data-plasmic-override={overrides.permissionSelectionStack}
          allowClear={true}
          bordered={false}
          className={classNames("__wab_instance", sty.permissionSelectionStack)}
          listHeight={256}
          mode={"multiple"}
          onChange={p.generateStateOnChangeProp($state, [
            "permissionSelectionStack",
            "value"
          ])}
          onDropdownVisibleChange={p.generateStateOnChangeProp($state, [
            "permissionSelectionStack",
            "open"
          ])}
          open={p.generateStateValueProp($state, [
            "permissionSelectionStack",
            "open"
          ])}
          placeholder={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___6U14W
              )}
            >
              {"Select"}
            </div>
          }
          showArrow={true}
          showSearch={true}
          size={"large"}
          value={p.generateStateValueProp($state, [
            "permissionSelectionStack",
            "value"
          ])}
          virtual={true}
        >
          <Option
            data-plasmic-name={"antdOption"}
            data-plasmic-override={overrides.antdOption}
            className={classNames("__wab_instance", sty.antdOption)}
            value={"Option"}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__lAu4X
              )}
            >
              {"Option"}
            </div>
          </Option>
        </Select>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__hKKww)}>
        <div
          data-plasmic-name={"permissionChipsStack"}
          data-plasmic-override={overrides.permissionChipsStack}
          className={classNames(projectcss.all, sty.permissionChipsStack)}
        >
          <PermissionChip
            data-plasmic-name={"permissionChip"}
            data-plasmic-override={overrides.permissionChip}
            className={classNames("__wab_instance", sty.permissionChip)}
          />
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__tyB8B)}>
        <Button
          data-plasmic-name={"saveEditRoleBtn"}
          data-plasmic-override={overrides.saveEditRoleBtn}
          className={classNames("__wab_instance", sty.saveEditRoleBtn)}
        >
          {"Save"}
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "roleName",
    "permissionSelectStack",
    "permissionSelect",
    "permissionSelectionStack",
    "antdOption",
    "permissionChipsStack",
    "permissionChip",
    "saveEditRoleBtn"
  ],

  roleName: ["roleName"],
  permissionSelectStack: [
    "permissionSelectStack",
    "permissionSelect",
    "permissionSelectionStack",
    "antdOption"
  ],

  permissionSelect: ["permissionSelect"],
  permissionSelectionStack: ["permissionSelectionStack", "antdOption"],
  antdOption: ["antdOption"],
  permissionChipsStack: ["permissionChipsStack", "permissionChip"],
  permissionChip: ["permissionChip"],
  saveEditRoleBtn: ["saveEditRoleBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEditRoleModal__ArgProps,
          internalVariantPropNames: PlasmicEditRoleModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEditRoleModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEditRoleModal";
  } else {
    func.displayName = `PlasmicEditRoleModal.${nodeName}`;
  }
  return func;
}

export const PlasmicEditRoleModal = Object.assign(
  // Top-level PlasmicEditRoleModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    roleName: makeNodeComponent("roleName"),
    permissionSelectStack: makeNodeComponent("permissionSelectStack"),
    permissionSelect: makeNodeComponent("permissionSelect"),
    permissionSelectionStack: makeNodeComponent("permissionSelectionStack"),
    antdOption: makeNodeComponent("antdOption"),
    permissionChipsStack: makeNodeComponent("permissionChipsStack"),
    permissionChip: makeNodeComponent("permissionChip"),
    saveEditRoleBtn: makeNodeComponent("saveEditRoleBtn"),
    // Metadata about props expected for PlasmicEditRoleModal
    internalVariantProps: PlasmicEditRoleModal__VariantProps,
    internalArgProps: PlasmicEditRoleModal__ArgProps
  }
);

export default PlasmicEditRoleModal;
/* prettier-ignore-end */
